import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ testPrefix = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid={`${testPrefix}theme-toggle`}
      aria-label="Toggle dark mode"
      onClick={toggle}
      className={`h-8 w-8 grid place-items-center rounded-sm border transition-colors ${
        theme === "dark"
          ? "border-white/20 bg-white/5 text-slate-100 hover:bg-white/10"
          : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
      }`}
    >
      {theme === "dark" ? <Sun className="h-4 w-4" strokeWidth={1.7} /> : <Moon className="h-4 w-4" strokeWidth={1.7} />}
    </button>
  );
}
